import OutletWrapper from '@/components/animations/animated-routes/animated-outlet';
import { Col } from '@/components/grid/grid-component';
import TabSelector from '@/components/page-tabs/page-tab-selector-component';
import { Heading2Text } from '@/utils/global-fonts';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const TabHolder = styled.div`
  padding: 32px 0 32px 32px;
`;

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const noWhiteSpace = { whiteSpace: 'nowrap' };

/**
 * User Management page component.
 * @returns {JSX.Element} The rendered User Management page component.
 */
const ProfileManagement = () => {
  const location = useLocation();
  const shop = location.pathname.includes('shop');

  const tabData = [
    {
      label: 'My Profile',
      path: shop
        ? '/shop/profile-management/profile'
        : '/app/profile-management/profile',
      permissions: ['user.read'],
    },
    {
      label: 'Change Password',
      path: shop
        ? '/shop/profile-management/profile/change-password'
        : '/app/profile-management/profile/change-password',
    },
  ];

  return (
    <TabHolder>
      <Col xs={9}>
        <Heading>
          <Heading2Text style={noWhiteSpace}>My Account</Heading2Text>
          <div id="tabPortal" />
        </Heading>
        <TabSelector tabs={tabData} />
        <OutletWrapper slide={25} slideUp={0} initial={false} />
      </Col>
    </TabHolder>
  );
};

export default ProfileManagement;
